module.exports = "/Public/build/47e89b26dbf9d4430a1ce4d16dd2d7c4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/cross.svg
// module id = 838
// module chunks = 0